const REASON_TEXT = {
  invalid_period: '指定摊分周期无效',
  missing_event_date: '缺少业务发生日期',
  missing_period: '缺少指定摊分周期',
};
const REASON_ORDER = ['missing_event_date', 'missing_period', 'invalid_period'];

const getMessages = ({ code, countUnit = '条数据', reasonText, suffix, warnings }) => {
  const groups = new Map();

  warnings.forEach((warning) => {
    if (warning.code !== code || !reasonText[warning.reason] || warning.count <= 0) {
      return;
    }

    const key = `${warning.metricId}:${warning.reason}`;
    const current = groups.get(key);
    groups.set(key, {
      ...warning,
      count: (current?.count || 0) + warning.count,
    });
  });

  return [...groups.values()]
    .sort(
      (left, right) =>
        left.metricName.localeCompare(right.metricName, 'zh-Hans-CN') ||
        REASON_ORDER.indexOf(left.reason) - REASON_ORDER.indexOf(right.reason) ||
        left.metricId.localeCompare(right.metricId),
    )
    .map(
      (warning) =>
        `${warning.metricName}：${reasonText[warning.reason]}，${warning.count} ${countUnit}${suffix}`,
    );
};

export const getMetricProjectionWarningMessages = (warnings = []) =>
  getMessages({
    code: 'invalid_metric_projection',
    reasonText: REASON_TEXT,
    suffix: '未参与计算',
    warnings,
  });

export const getMetricProjectionFallbackMessages = (warnings = []) =>
  getMessages({
    code: 'metric_projection_fallback',
    reasonText: { missing_period: REASON_TEXT.missing_period },
    suffix: '已按不摊分规则计入',
    warnings,
  });

export const getMetricRatioConflictMessages = (warnings = []) =>
  getMessages({
    code: 'metric_ratio_source_conflict',
    countUnit: '个冲突周期',
    reasonText: { multiple_actual_values: '同一周期存在多个实际比率' },
    suffix: '已按最新数据取值',
    warnings,
  });
